import { Spec } from '@playground/SQL/models/tests.model';
import { FunctionComponent } from 'react';
import Test from './Test';

interface Props {
  specs: Spec[];
}

const Specs: FunctionComponent<Props> = ({ specs }) => {
  return (
    <div>
      {specs.map((spec, index) => {
        return (
          <div key={`spec-${index}`}>
            {Object.values(spec.tests).map((test, index) => (
              <Test key={index} test={test} />
            ))}
          </div>
        );
      })}
    </div>
  );
};

export default Specs;
